import update from 'immutability-helper';

import {ManageWisbitState, ManageWisbitActionType} from '../types';
import {
  LOAD_WISBITS_SUCCESS,
  LOAD_WISBITS_FAILURE,
  LOAD_WISBITS_REQUEST,
} from './actions';

const initialState: ManageWisbitState = {};

export default function manageWisbitReducer(
  state = initialState,
  action: ManageWisbitActionType
): ManageWisbitState {
  const {type, payload} = action;

  switch (type) {
    case LOAD_WISBITS_REQUEST:
      return update(state, {
        loading: {$set: true},
      });
    case LOAD_WISBITS_SUCCESS:
      return update(state, {
        loading: {$set: false},
        data: {$set: payload.data || []},
      });
    case LOAD_WISBITS_FAILURE:
      return update(state, {
        loading: {$set: false},
        error: {$set: payload.error},
      });
    default:
      return state;
  }
}
